export default {
  INVESTOR: 'INVESTOR',
  BACKOFFICE: 'BACKOFFICE',
  BASIC: 'BASIC',
  BASIC_BACKOFFICE: 'BASIC_BACKOFFICE',
  CLIENT: 'CLIENT',
  BACKOFFICE_TREASURER: 'BACKOFFICE_TREASURER',
  // CUSTOMER_SUPPORT: 'CUSTOMER_SUPPORT',
  BACKOFFICE_FINANCE: 'BACKOFFICE_FINANCE',
  BACKOFFICE_COLLECTION: 'BACKOFFICE_COLLECTION',
  INSTITUCIONAL_VENDOR: 'INSTITUTIONAL_VENDOR',
  PROSPECT: 'PROSPECT',
  ADMIN: 'ADMIN'
};
